import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { fromStoreByIdQueryToStore } from '../../adapters/from-store-by-id-query-to-store.js';
import { GET_BOOK_APPOINTMENT_STORE_BY_ID } from '../../queries/get-book-appointment-store-by-id.js';

const useBookAppointmentStoreById = ({ isTryInStoreFlowEnabled =false  } = {})=>{
    const [query, queryState] = useLazyQuery(GET_BOOK_APPOINTMENT_STORE_BY_ID);
    const { locale  } = useIntl();
    if (queryState.error) {
        console.error(queryState.error);
    }
    const getBookAppointmentStoreById = React.useCallback((globalStoreId)=>query(swcHelpers.objectSpread({
            variables: {
                globalStoreId
            }
        }, locale ? {
            context: {
                forwardHeaders: {
                    'Accept-Language': locale
                }
            }
        } : {}))
    , [
        query,
        locale
    ]);
    const data = React.useMemo(()=>{
        var ref;
        return fromStoreByIdQueryToStore((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store, [
            {
                tryInStore: isTryInStoreFlowEnabled
            }
        ]);
    }, [
        queryState.data
    ]);
    return React.useMemo(()=>[
            getBookAppointmentStoreById,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getBookAppointmentStoreById,
        queryState,
        data
    ]);
};

export { useBookAppointmentStoreById as default };
//# sourceMappingURL=use-book-appointment-store-by-id.js.map
